import {Component, Input, OnInit} from '@angular/core';
import {IntegrationModule} from "../../../../../model/integration-module";
import {DefaultDeviceCatalog} from "../../../../../model/default-device-catalog";

@Component({
  selector: 'app-default-device-integration-modules',
  templateUrl: './default-device-integration-modules.component.html',
  styleUrls: ['./default-device-integration-modules.component.scss']
})
export class DefaultDeviceIntegrationModulesComponent implements OnInit {

  @Input()
  public defaultDeviceCatalog: DefaultDeviceCatalog;

  public integrationModules: IntegrationModule[];
  public totalModules: number;
  public loadingModules: boolean;

  public rows = 10;
  public first = 0;

  constructor() {
    this.integrationModules = [];
  }

  ngOnInit(): void {
    this.loadIntegrationModules();
  }

  loadIntegrationModules() {
    this.loadingModules = true;
    this.integrationModules = new Array(this.rows);
    this.integrationModules = this.defaultDeviceCatalog.content?.integrationModules ? this.defaultDeviceCatalog.content.integrationModules : [];
    let dataKey = 0;
    this.integrationModules.forEach(module => {
      if (module.additionalInfo) {
        try {
          module.additionalInfo = JSON.parse(module.additionalInfo);
        } catch (e) {
          module.additionalInfo = null;
        }
      }
      if (module.technicalDetails) {
        try {
          module.technicalDetails = JSON.parse(module.technicalDetails);
        } catch (e) {
          module.technicalDetails = null;
        }
      }
      module['dataKey'] = dataKey++;
    });
    this.totalModules = this.integrationModules.length;
    this.loadingModules = false;
  }

}
